import { render, staticRenderFns } from "./DFAttachedFileURL.vue?vue&type=template&id=2a753c16&"
import script from "./DFAttachedFileURL.vue?vue&type=script&lang=js&"
export * from "./DFAttachedFileURL.vue?vue&type=script&lang=js&"
import style0 from "./DFAttachedFileURL.vue?vue&type=style&index=0&id=2a753c16&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports